module.exports = __webpack_public_path__ + "img/slide22.f08cef25.jpg";